import { t } from "@impero-com/common/utils/i18n";
import { Button, InformationModal, renderMarkdown } from "@impero-com/ui";
import { useNavigate } from "react-router-dom";

import * as R from "org/risks/types";

import { RISK_DIRECTORY_HASH } from "..";
import { WebRoute } from "../../../../routes";

import { useCopyRiskDirectoryMutation } from "./queries/useCopyRiskDirectoryMutation";

export interface CopyWithConfirmationDialogProps {
    riskDirectory: R.RiskDirectoryView;
    onCancel: () => void;
}

export const CopyWithConfirmationDialog = ({
    riskDirectory,
    onCancel,
}: CopyWithConfirmationDialogProps) => {
    const navigate = useNavigate();
    const { mutateAsync, isPending } = useCopyRiskDirectoryMutation(
        riskDirectory.content.resource.id,
        riskDirectory.content.resource.title,
        (riskDirectoryCopy) => {
            navigate(
                `${WebRoute.RISKS}/${riskDirectoryCopy.id}${RISK_DIRECTORY_HASH}`
            );
        }
    );

    return (
        <InformationModal
            open
            onClose={onCancel}
            type="info"
            icon="duplicate"
            title={t("RiskDirectory_View_Copy_Title")}
            footer={
                <>
                    <Button onClick={onCancel}>{t("Cancel")}</Button>
                    <Button
                        variant="primary"
                        disabled={isPending}
                        loading={isPending}
                        onClick={() => void mutateAsync(undefined)}
                    >
                        {t("Duplicate")}
                    </Button>
                </>
            }
        >
            {renderMarkdown(
                t("RiskDirectory_View_Copy_Body", {
                    name: riskDirectory.content.resource.title,
                })
            )}
        </InformationModal>
    );
};
